import React, { useCallback } from 'react';

//Hooks
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

//Components
import { Navbar, Container } from 'react-bootstrap';

//Components
import { ChevronLeft, X } from 'react-feather';

import { WIDGET_STYLE } from '../../const/app/WIDGET_STYLE';
import { ROUTER_URL } from '../../const/ROUTER_URL';
import { ROUTER_PATH } from '../../const/ROUTER_PATH';
import { OLD_INTEGRATION_EVENT } from '../../const/integration/OLD_INTEGRATION_LIBRARY_EVENT';

//Styles
import Styles from './Header.module.scss';

const Header = () => {
    const location = useLocation();
    const history = useHistory();
    const shopId = useSelector(state => state.companies.shopId);
    const { company_logo: logo, name } = useSelector(state => state.companies.selectedCompany.company);
    const style = useSelector(state => state.widget.style);
    const showCloseButton = useSelector(state => state.widget.showCloseButton);
    const { services: showServices } = useSelector(state => state.companies.shop ? state.companies.shop.products : { services: true });

    const devOrWebsiteStyle = [WIDGET_STYLE.DEV, WIDGET_STYLE.WEBSITE].includes(style);

    const parts = location.pathname.split('/').filter(part => part.length !== 0);

    let route;
    if (parts.join('/').match(/event\/[0-9]*/)) {
        route = ROUTER_URL.SHOPS_ID_EVENTS({ shopId });
    } else if (parts.join('/').match(/bundle\/[0-9]*/)) {
        route = ROUTER_URL.SHOPS_ID_BUNDLES({ shopId });
    } else if (parts.join('/').match(/reservations\/details\/(product|bundle)\/[0-9]*\/1/)) {
        route = ROUTER_URL.RESERVATIONS;
    } else if (parts.join('/').match(/reservations\/details\/(product|bundle)\/[0-9]*\/0/)) {
        route = ROUTER_URL.RESERVATIONS_HISTORY;
    } else if (parts.join('/').match(/signin\/.*/)) {
        route = ROUTER_URL.SHOPS;
    } else if (!devOrWebsiteStyle && !showServices && parts.join('/').match(/shops\/[0-9]*\/(groups|events|bundles)/)) {
        route = ROUTER_URL.SHOPS;
    } else if (parts.join('/').match(/notifications\/promotions\/[0-9]*/)) {
        route = ROUTER_URL.NOTIFICATIONS;
    } else {
        switch (parts.join('/')) {
            case 'book':
                route = ROUTER_URL.SHOPS_ID({ shopId });
                break;
            case 'book/confirm/service':
                route = ROUTER_URL.BOOK;
                break;
            case 'book/confirm/group':
                route = ROUTER_URL.SHOPS_ID_GROUPS({ shopId });
                break;
            case 'book/confirm/event':
                route = ROUTER_URL.SHOPS_ID_EVENTS({ shopId });
                break;
            case 'book/confirm/bundle':
                route = ROUTER_URL.SHOPS_ID_BUNDLES({ shopId });
                break;
            case 'subscription-details':
                route = ROUTER_URL.SHOPS_ID_SUBSCRIPTIONS({ shopId });
                break;
            default:
                route = `/${parts.slice(0, parts.length - 1).join('/')}`;
                break;
        }
    }

    const isShopsMatch = useRouteMatch({
        path: ROUTER_PATH.SHOPS,
        exact: true,
    });

    const handleGoBack = useCallback(() => {
        if (route.split('/')[1] === 'shops' && route.split('/').length === 3) {
            history.push('/shops');
        } else {
            history.replace(route);
        }
    }, [history, route]);

    const handleClose = useCallback(() => {
        window.parent.postMessage(OLD_INTEGRATION_EVENT.CLOSE, '*');
    }, []);

    return (
        <header className={[
            Styles.container,
            style === 'inline' ? Styles.inline : ''
        ].join(' ')}>
            <Navbar>
                <Container>
                    <div className={Styles.backArrowContainer}>
                        {!isShopsMatch && (
                            <button
                                className={Styles.button}
                                onClick={handleGoBack}
                            >
                                <ChevronLeft/>
                            </button>
                        )}
                    </div>

                    <div className={Styles.companyContainer}>
                        <img className={Styles.companyImage} src={logo} alt=""/>

                        <p className={Styles.companyName} data-testid="data-test-companyName">
                            {name}
                        </p>
                    </div>

                    <div className={Styles.closeArrowContainer}>
                        {/* istanbul ignore next */ window !== window.parent && !devOrWebsiteStyle && showCloseButton && (
                            <button
                                className={Styles.button}
                                onClick={handleClose}
                            >
                                <X/>
                            </button>
                        )}
                    </div>
                </Container>
            </Navbar>
        </header>
    );
};

export default Header
